module.exports = __webpack_public_path__ + "media/images/footer/la-riposte-157b302478d9fbb1b1778c893fbd4f81.png";